// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/logo/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authPage_main-container__JyogV {
  width: 100vw;
  min-height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-position-x: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
}
.authPage_main-container__JyogV div {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  max-width: 440px;
  width: 440px;
  padding: 44px;
  margin-bottom: 28px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.466);
  min-width: 320px;
  min-height: 338px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.authPage_main-container__JyogV div h1 {
  text-align: left;
  font: 300 55px/30px Montserrat, sans-serif; /* Consolidated font properties */
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.authPage_main-container__JyogV div p {
  text-align: left;
  font: 300 29px/58px Montserrat, sans-serif; /* Consolidated font properties */
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.authPage_main-container__JyogV div section {
  background-color: rgba(252, 165, 165, var(--tw-bg-opacity));
}

.authPage_bsk-container__bP\\+\\+o {
  margin-top: 15px;
}
.authPage_bsk-container__bP\\+\\+o button {
  display: flex;
  gap: 12px;
  font-size: 15px;
  align-items: center;
  background: #0068b8;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.26);
  padding: 12px;
  color: #fff;
  margin-top: 25px;
  border: none;
  border-radius: 6px;
}
.authPage_bsk-container__bP\\+\\+o object {
  width: 25px;
  height: 25px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Login/authPage.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;EACA,yDAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AACF;AAAE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EAGA,0CAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAEJ;AADI;EACE,gBAAA;EACA,0CAAA,EAAA,iCAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AAGN;AADI;EACE,gBAAA;EACA,0CAAA,EAAA,iCAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AAGN;AAAI;EACE,2DAAA;AAEN;;AAEA;EACE,gBAAA;AACF;AAAE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AAAE;EACE,WAAA;EACA,YAAA;AAEJ","sourcesContent":[".main-container {\r\n  width: 100vw;\r\n  min-height: 100vh;\r\n  background-image: url('../../../assets/logo/bg.png'); // Use correct path\r\n  background-position: center;\r\n  background-position-x: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  display: flex;\r\n  align-items: center;\r\n  div {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    position: relative;\r\n    max-width: 440px;\r\n    width: 440px;\r\n    padding: 44px;\r\n    margin-bottom: 28px;\r\n    background-color: #fff;\r\n    -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n    -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.466);\r\n    min-width: 320px;\r\n    min-height: 338px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 8px;\r\n    h1 {\r\n      text-align: left;\r\n      font: 300 55px/30px Montserrat, sans-serif; /* Consolidated font properties */\r\n      letter-spacing: 0px;\r\n      color: #ffffff;\r\n      opacity: 1;\r\n  }\r\n    p {\r\n      text-align: left;\r\n      font: 300 29px/58px Montserrat, sans-serif; /* Consolidated font properties */\r\n      letter-spacing: 0px;\r\n      color: #ffffff;\r\n      opacity: 1;\r\n  }\r\n  \r\n    section {\r\n      background-color: rgba(252, 165, 165, var(--tw-bg-opacity));\r\n    }\r\n  }\r\n}\r\n.bsk-container {\r\n  margin-top: 15px;\r\n  button {\r\n    display: flex;\r\n    gap: 12px;\r\n    font-size: 15px;\r\n    align-items: center;\r\n    background: #0068b8;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.26);\r\n    padding: 12px;\r\n    color: #fff;\r\n    margin-top: 25px;\r\n    border: none;\r\n    border-radius: 6px;\r\n  }\r\n  object {\r\n    width: 25px;\r\n    height: 25px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-container": `authPage_main-container__JyogV`,
	"bsk-container": `authPage_bsk-container__bP++o`
};
export default ___CSS_LOADER_EXPORT___;
